import { AUTH_TOKENS } from "constants/storageKeys";

export const isAuthTokenPresent = (): boolean => {
  try {
    return Boolean(
      JSON.parse(localStorage.getItem(AUTH_TOKENS) || "null")?.access
    );
  } catch {
    return false;
  }
};
